/**
 * AlertBar component type options.
 * Treat this file as an enum.
 * @module alertBarTypes
 * @category AlertBar
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Use success CSS styles
 * @type {string}
 */
export const SUCCESS = "SUCCESS";

/**
 * Use warning CSS styles
 * @type {string}
 */
export const WARNING = "WARNING";

/**
 * Use error CSS styles
 * @type {string}
 */
export const ERROR = "ERROR";

/**
 * Use info CSS styles
 * @type {string}
 */
export const INFO = "INFO";
